const a = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, A = {
  start: "end",
  center: "center",
  end: "start"
}, X = {
  top: "height",
  bottom: "height",
  left: "width",
  right: "width"
}, C = {
  "bottom-start": "top left",
  bottom: "top center",
  "bottom-end": "top right",
  "top-start": "bottom left",
  top: "bottom center",
  "top-end": "bottom right",
  "right-start": "top left",
  right: "center left",
  "right-end": "bottom left",
  "left-start": "top right",
  left: "center right",
  "left-end": "bottom right"
}, z = {
  "bottom-start": "bottom left",
  bottom: "bottom center",
  "bottom-end": "bottom right",
  "top-start": "top left",
  top: "top center",
  "top-end": "top right",
  "right-start": "top right",
  right: "center right",
  "right-end": "bottom right",
  "left-start": "top left",
  left: "center left",
  "left-end": "bottom left"
}, k = {
  "bottom-start": "right",
  "bottom-end": "left",
  "top-start": "right",
  "top-end": "left",
  "right-start": "bottom",
  "right-end": "top",
  "left-start": "bottom",
  "left-end": "top"
}, O = {
  top: !0,
  bottom: !1,
  left: !0,
  right: !1
  // left--
}, v = {
  top: "end",
  bottom: "start",
  left: "end",
  right: "start"
};
function y(s, n, o, t, l, f) {
  if (!l || f)
    return { placement: s, top: 0, left: 0 };
  const [h, x] = s.split("-");
  let u = x != null ? x : "center", $ = {
    top: 0,
    left: 0
  };
  const m = (p, i, r) => {
    let d = 0, Y = 0;
    const M = o[p] - n[i] - n[p];
    return M > 0 && t && (r ? Y = O[i] ? M : -M : d = O[i] ? M : -M), {
      left: d,
      top: Y
    };
  }, b = h === "left" || h === "right";
  if (u !== "center") {
    const p = k[s], i = a[p], r = X[p];
    if (o[r] > n[r]) {
      if (
        // current space is not enough
        // ----------[ target ]---------|
        // -------[     follower        ]
        n[p] + n[r] < o[r]
      ) {
        const d = (o[r] - n[r]) / 2;
        n[p] < d || n[i] < d ? n[p] < n[i] ? (u = A[x], $ = m(r, i, b)) : $ = m(r, p, b) : u = "center";
      }
    } else
      o[r] < n[r] && n[i] < 0 && // opposite align has larger space
      // ------------[   target   ]
      // ----------------[follower]
      n[p] > n[i] && (u = A[x]);
  } else {
    const p = h === "bottom" || h === "top" ? "left" : "top", i = a[p], r = X[p], d = (o[r] - n[r]) / 2;
    // center is not enough
    // ----------- [ target ]--|
    // -------[     follower     ]
    (n[p] < d || n[i] < d) && (n[p] > n[i] ? (u = v[p], $ = m(r, p, b)) : (u = v[i], $ = m(r, i, b)));
  }
  let w = h;
  return (
    // space is not enough
    n[h] < o[X[h]] && // opposite position's space is larger
    n[h] < n[a[h]] && (w = a[h]), {
      placement: u !== "center" ? `${w}-${u}` : w,
      left: $.left,
      top: $.top
    }
  );
}
function D(s, n) {
  return n ? z[s] : C[s];
}
function F(s, n, o, t, l, f) {
  if (f)
    switch (s) {
      case "bottom-start":
        return {
          top: `${Math.round(o.top - n.top + o.height)}px`,
          left: `${Math.round(o.left - n.left)}px`,
          transform: "translateY(-100%)"
        };
      case "bottom-end":
        return {
          top: `${Math.round(o.top - n.top + o.height)}px`,
          left: `${Math.round(o.left - n.left + o.width)}px`,
          transform: "translateX(-100%) translateY(-100%)"
        };
      case "top-start":
        return {
          top: `${Math.round(o.top - n.top)}px`,
          left: `${Math.round(o.left - n.left)}px`,
          transform: ""
        };
      case "top-end":
        return {
          top: `${Math.round(o.top - n.top)}px`,
          left: `${Math.round(o.left - n.left + o.width)}px`,
          transform: "translateX(-100%)"
        };
      case "right-start":
        return {
          top: `${Math.round(o.top - n.top)}px`,
          left: `${Math.round(o.left - n.left + o.width)}px`,
          transform: "translateX(-100%)"
        };
      case "right-end":
        return {
          top: `${Math.round(o.top - n.top + o.height)}px`,
          left: `${Math.round(o.left - n.left + o.width)}px`,
          transform: "translateX(-100%) translateY(-100%)"
        };
      case "left-start":
        return {
          top: `${Math.round(o.top - n.top)}px`,
          left: `${Math.round(o.left - n.left)}px`,
          transform: ""
        };
      case "left-end":
        return {
          top: `${Math.round(o.top - n.top + o.height)}px`,
          left: `${Math.round(o.left - n.left)}px`,
          transform: "translateY(-100%)"
        };
      case "top":
        return {
          top: `${Math.round(o.top - n.top)}px`,
          left: `${Math.round(o.left - n.left + o.width / 2)}px`,
          transform: "translateX(-50%)"
        };
      case "right":
        return {
          top: `${Math.round(o.top - n.top + o.height / 2)}px`,
          left: `${Math.round(o.left - n.left + o.width)}px`,
          transform: "translateX(-100%) translateY(-50%)"
        };
      case "left":
        return {
          top: `${Math.round(o.top - n.top + o.height / 2)}px`,
          left: `${Math.round(o.left - n.left)}px`,
          transform: "translateY(-50%)"
        };
      case "bottom":
      default:
        return {
          top: `${Math.round(o.top - n.top + o.height)}px`,
          left: `${Math.round(o.left - n.left + o.width / 2)}px`,
          transform: "translateX(-50%) translateY(-100%)"
        };
    }
  switch (s) {
    case "bottom-start":
      return {
        top: `${Math.round(o.top - n.top + o.height + t)}px`,
        left: `${Math.round(o.left - n.left + l)}px`,
        transform: ""
      };
    case "bottom-end":
      return {
        top: `${Math.round(o.top - n.top + o.height + t)}px`,
        left: `${Math.round(o.left - n.left + o.width + l)}px`,
        transform: "translateX(-100%)"
      };
    case "top-start":
      return {
        top: `${Math.round(o.top - n.top + t)}px`,
        left: `${Math.round(o.left - n.left + l)}px`,
        transform: "translateY(-100%)"
      };
    case "top-end":
      return {
        top: `${Math.round(o.top - n.top + t)}px`,
        left: `${Math.round(o.left - n.left + o.width + l)}px`,
        transform: "translateX(-100%) translateY(-100%)"
      };
    case "right-start":
      return {
        top: `${Math.round(o.top - n.top + t)}px`,
        left: `${Math.round(o.left - n.left + o.width + l)}px`,
        transform: ""
      };
    case "right-end":
      return {
        top: `${Math.round(o.top - n.top + o.height + t)}px`,
        left: `${Math.round(o.left - n.left + o.width + l)}px`,
        transform: "translateY(-100%)"
      };
    case "left-start":
      return {
        top: `${Math.round(o.top - n.top + t)}px`,
        left: `${Math.round(o.left - n.left + l)}px`,
        transform: "translateX(-100%)"
      };
    case "left-end":
      return {
        top: `${Math.round(o.top - n.top + o.height + t)}px`,
        left: `${Math.round(o.left - n.left + l)}px`,
        transform: "translateX(-100%) translateY(-100%)"
      };
    case "top":
      return {
        top: `${Math.round(o.top - n.top + t)}px`,
        left: `${Math.round(o.left - n.left + o.width / 2 + l)}px`,
        transform: "translateY(-100%) translateX(-50%)"
      };
    case "right":
      return {
        top: `${Math.round(o.top - n.top + o.height / 2 + t)}px`,
        left: `${Math.round(o.left - n.left + o.width + l)}px`,
        transform: "translateY(-50%)"
      };
    case "left":
      return {
        top: `${Math.round(o.top - n.top + o.height / 2 + t)}px`,
        left: `${Math.round(o.left - n.left + l)}px`,
        transform: "translateY(-50%) translateX(-100%)"
      };
    case "bottom":
    default:
      return {
        top: `${Math.round(o.top - n.top + o.height + t)}px`,
        left: `${Math.round(o.left - n.left + o.width / 2 + l)}px`,
        transform: "translateX(-50%)"
      };
  }
}
export {
  F as getOffset,
  y as getPlacementAndOffsetOfFollower,
  D as getProperTransformOrigin
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vueuc@0.4.64_vue@3.5.18/~/vueuc/es/binder/src/get-placement-style.js
// module id = 1739
// module chunks = 41